import {priority} from '@priority-software/priority-proto-api/lib';

import {ColumnTypeToCodeMap} from '../../../features/AppSearches/types/column';
import {ISearchField} from '../../../common/searchType';

export const serializeField = (column: priority.netitems.form.IColumn): ISearchField => {
    const {ID, Title, Type, Zoom, SearchAll, Decimal, Width, Name, DefaultValue, Relcol} = column;
    const isZoom = Zoom === priority.netitems.form.ZoomType.SelectZoom && !Relcol;

    return {
        defaultValue: DefaultValue,
        columnName: Name,
        columnID: ID,
        title: Title,
        type: Type,
        isZoom,
        isChoose: isZoom && !SearchAll,
        searchAll: SearchAll,
        decimal: Decimal,
        maxLength: Number(Width),
        code: ColumnTypeToCodeMap[Type]
    };
};
